import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { UserService } from '../../core';
import { MerchantProfile, MerchantProfileComponent, AddMerchantAccessUsersComponent, MerchantAccountListItem } from '../../shared';

@Component({
    selector: 'app-my-merchant-accounts',
    templateUrl: './my-merchant-accounts.component.html',
    styleUrls: ['./my-merchant-accounts.component.css']
})
export class MyMerchantAccountsComponent implements OnInit, OnDestroy {

    merchantAccounts: MerchantAccountListItem[];
    private modalRef: NgbModalRef;
    private userSubscription: Subscription;
    isAdmin: boolean = false;
    isPrimaryContact: boolean = false;

    constructor(
        private readonly route: ActivatedRoute,
        private modalService: NgbModal,
        private readonly userService: UserService
    ) {
    }

    ngOnInit(): void {
        this.route.data.subscribe(({ merchantAccounts }: { merchantAccounts: MerchantAccountListItem[] }) => {
            this.merchantAccounts = merchantAccounts;
        });
        this.userSubscription = this.userService.user$.subscribe(user => {
            this.isAdmin = user.isAdmin();
            this.isPrimaryContact = user.isPrimaryContact();
        });
    }

    ngOnDestroy(): void {
        if (this.userSubscription) {
            this.userSubscription.unsubscribe();
        }
    }

    openMerchantProfileModal() {
        this.modalRef = this.modalService.open(MerchantProfileComponent, { size: 'lg' });
        this.modalRef.componentInstance.merchantProfile = { id: null, name: null, defaultContact: null, accessUsers: []} as MerchantProfile;
    }

    openAddMerchantAccessUsersModal() {
        this.modalRef = this.modalService.open(AddMerchantAccessUsersComponent, { size: 'lg' });
        this.modalRef.componentInstance.merchantProfile = { id: null } as MerchantProfile;
    }
}